export default __webpack_public_path__ + "static/media/download_EDO project ‘voor elkaar’_doelenlijst.056cbdad.pdf";